import { render, staticRenderFns } from "./BrokerView.vue?vue&type=template&id=7bcda888&scoped=true"
import script from "./BrokerView.vue?vue&type=script&lang=js"
export * from "./BrokerView.vue?vue&type=script&lang=js"
import style0 from "./BrokerView.vue?vue&type=style&index=0&id=7bcda888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcda888",
  null
  
)

export default component.exports